<script>
export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: Array, // Expecting an array of strings
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      value: Array.isArray(this.item_value) ? this.item_value : [],
    };
  },
  watch: {
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
  },
  mounted() {
    if (this.value.length === 0) {
      this.value.push({
        label: "Register at our GP Practice",
        externallink: "",
      });
    }
  },
  methods: {
    addTextInput() {
      if (this.value.length === 0) {
        this.value.push({
          label: "Register at our GP Practice",
          externallink: "",
        });
      } else {
        this.value.push({ label: "", externallink: "" });
      }
    },
    removeTextInput(index) {
      this.value.splice(index, 1);
    },
  },
};
</script>

<template>
  <!-- Register at our GP Practice -->
  <div class="mb-3">
    <!-- Label always visible -->
    <div class="d-flex mb-2 link-lable">
      <div style="width: 47%">
        {{ "Label" }}
      </div>
      <div>
        {{ "Link" }}
      </div>
      <div @click="removeTextInput(index)" class="rm-action"></div>
    </div>
    <div v-for="(val, index) in value" :key="index" class="d-flex mb-2">
      <input
        v-model="val.label"
        type="text"
        class="form-control mr-2"
        :placeholder="'Enter Label'"
        :class="{
          'is-invalid': submitted && validation.$error,
        }"
      />
      <input
        v-model="val.externallink"
        type="text"
        class="form-control mr-2"
        :placeholder="'Enter Link'"
        :class="{
          'is-invalid': submitted && validation.$error,
        }"
      />
      <div @click="removeTextInput(index)" class="rm-action">Remove</div>
    </div>
    <div
      v-if="item.limit > value.length"
      @click="addTextInput"
      class="font-size-14 mb-2 ml-auto align-self-sm-center cursor-pointer font-weight-medium add-action"
    >
      + Add Items
    </div>
    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>

<style>
.is-invalid {
  border-color: red;
}
.add-action {
  color: #035db8;
  padding-top: 5px;
  font-weight: 400;
}
.rm-action {
  color: red;
  padding-top: 5px;
  font-weight: 400;
  cursor: pointer;
}
.link-lable {
  font-weight: 500;
  color: #333333 !important;
  font-size: 14px;
}
</style>
